import { RemoteIcon } from './RemoteIcon';

/**
 * author: Google
 * id 49C7BBC2-6C7F-442E-A6EE-B58AB758A8D4
 * name remote
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/remote.svg
 * tags
 * - Home Automation 
 */
export const SettingsRemoteIcon = RemoteIcon;
export default SettingsRemoteIcon